// Module
var code = "<div class=\"row-preview\">\n    {{tmpl \"#edit-record-field-label\"}}\n    <div class=\"validation-container clear\">\n        <input class=\"error-container\" type=\"hidden\"></input>\n        <div class=\"react-container\"></div>\n    </div>\n</div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#edit-record-portfolio-dropdown-template'] = htmlContent;
module.exports = "edit-record-portfolio-dropdown-template";